import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Autocomplete from "@mui/material/Autocomplete";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { autoTable } from "jspdf-autotable";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";

import { useNavigate } from "react-router-dom";

import { RABSearchParams, getRab, createRab, uploadRabPhoto, editRab, fetchRabPhotoBlob, deleteRab, RABDetailSearchParams, getRabDetail, deleteRabDetail, SCurveSearchParams, getSCurve, createRabDetail, createSCurve, deleteSCurve } from "../services/rabService.tsx";
import { fetchAhs } from "../services/ahsService.tsx";
import { getAllProjects } from "../services/projectListingService.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

const grafanaURL = process.env.REACT_APP_GRAFANA_URL || "http://localhost:3000";



// Dummy Data
const rabReviewData = [
  {
    keterangan: "Sewa Perancah",
    volume: 1,
    satuan: "Ls",
    hargaSatuan: 5000000,
    jumlahHarga: 5000000
  },
  {
    keterangan: "Pembongkaran Atap",
    volume: 30,
    satuan: "M2",
    hargaSatuan: 1000000,
    jumlahHarga: 30000000
  },
  {
    keterangan: "Pemasangan Seng",
    volume: 580,
    satuan: "LS",
    hargaSatuan: 1000000,
    jumlahHarga: 580000000
  }
];

const jumlahHarga = rabReviewData.reduce((acc, curr) => acc + curr.jumlahHarga, 0);
const ppn = Math.round(jumlahHarga * 0.11);
const totalHarga = jumlahHarga + ppn;

const sCurveData = [
  {
    category: "Pekerjaan Persiapan",
    keterangan: "Sewa Perancah",
    nilai: 5000000,
    bobot: 0.75,
    bobotMinggu: 0.04,
    durasi: "3 Weeks",
    start: "01/07/2021",
    end: "22/07/2021"
  },
  {
    category: "Pekerjaan Atap",
    keterangan: "Pembongkaran Atap",
    nilai: 10000000,
    bobot: 1,
    bobotMinggu: 0.5,
    durasi: "2 Weeks",
    start: "01/07/2021",
    end: "15/07/2021"
  },
  {
    category: "Pekerjaan Atap",
    keterangan: "Pemasangan Seng",
    nilai: 1000000,
    bobot: 90,
    bobotMinggu: 90,
    durasi: "1 Weeks",
    start: "01/08/2021",
    end: "08/08/2021"
  }
];


const projectTypeColors = {
  "PST": "green",
  "MB": "lightgreen",
  "PJTK": "#164396  ",
  "KON": "gray",
  "SK": "orange"
};

const sources = ["PLN", "BUMN Non-PLN", "Swasta", "Pemerintahan"];
const projectTypes = ["Residential", "Commercial", "Infrastructure", "Industrial"];
const constructionPhases = ["Planning", "Design", "Procurement", "Execution", "Finishing"];
const regions = ["Jamali", "Sulmapana", "Sumkal"];

const RABPage: React.FC = () => {
  const grafanaChartRef = useRef<HTMLDivElement>(null);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddRabDialog, setOpenAddRabDialog] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [startDateS, setStartDateS] = useState<string | null>(null);
  const [endDateS, setEndDateS] = useState<string | null>(null);

  const [startDateE, setStartDateE] = useState<string | null>(null);
  const [endDateE, setEndDateE] = useState<string | null>(null);

  const [valueMin, setValueMin] = useState("");
  const [valueMax, setValueMax] = useState("");

  const [isEditedRabDetail, setIsEditedRabDetail] = useState(false);
  const [isEditedSCurve, setIsEditedSCurve] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const [ahsOptions, setAhsOptions] = useState<any[]>([]);
  const [projectOptions, setProjectOptions] = useState<any[]>([]);


  const [totalRabAdd, setTotalRabAdd] = useState(0);
  const [totalRabEdit, setTotalRabEdit] = useState(0);

  const [bobotAdd, setBobotAdd] = useState(0);
  const [bobotEdit, setBobotEdit] = useState(0);


  const nullProject = {
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  }

  const [projectAdd, setProjectAdd] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [projectEdit, setProjectEdit] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const fetchAhsList = async () => {
    try {
      const result = await fetchAhs();
      setAhsOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const fetchProjectList = async () => {
    try {
      const result = await getAllProjects();
      setProjectOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  function terbilang(nilai) {
    const angka = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];

    function convert(n) {
      n = Math.floor(n);
      if (n < 12) return angka[n];
      else if (n < 20) return convert(n - 10) + " Belas";
      else if (n < 100) return convert(Math.floor(n / 10)) + " Puluh " + convert(n % 10);
      else if (n < 200) return "Seratus " + convert(n - 100);
      else if (n < 1000) return convert(Math.floor(n / 100)) + " Ratus " + convert(n % 100);
      else if (n < 2000) return "Seribu " + convert(n - 1000);
      else if (n < 1000000) return convert(Math.floor(n / 1000)) + " Ribu " + convert(n % 1000);
      else if (n < 1000000000) return convert(Math.floor(n / 1000000)) + " Juta " + convert(n % 1000000);
      else if (n < 1000000000000) return convert(Math.floor(n / 1000000000)) + " Miliar " + convert(n % 1000000000);
      else return "Angka terlalu besar";
    }

    return convert(nilai).replace(/\s+/g, " ").trim();
  }


  const showPopupMandatoryError = (detail) => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: detail,
    });
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "projectName", label: "Project Name" },
    { value: "source", label: "Source" },
    { value: "projectReferenceId", label: "Kode Project" },
    { value: "region", label: "Region" },
    { value: "projectType", label: "Project Type" },
    { value: "constructionPhase", label: "Project Phase" },
    { value: "valueEstimation", label: "Value Estimation" },
    { value: "projectAddress", label: "Project Address" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "projectName", label: "Project Name" },
    { value: "source", label: "Source" },
    { value: "projectReferenceId", label: "Kode Project" },
    { value: "region", label: "Region" },
    { value: "projectType", label: "Project Type" },
    { value: "constructionPhase", label: "Project Phase" },
    { value: "valueEstimation", label: "Value Estimation" },
    { value: "projectAddress", label: "Project Address" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    projectName?: string;
    projectAddress?: string;
    projectReferenceId?: string;
    source?: string;
    projectType?: string;
    constructionPhase?: string;
    region?: string;
    city?: string;
    state?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    salesProjectId?: string;
    valueEstimation?: string;
    startDate?: string;
    endDate?: string;
    startDateS?: string;
    endDateS?: string;
    startDateE?: string;
    endDateE?: string;
    valueMin?: string;
    valueMax?: string;
    limit?: number;
    offset?: number;
    orderBy?: string;
    order?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchRabs = async () => {
    setIsLoading(true);
    try {


      const result = await getRab({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });



      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchProjectList();
    fetchAhsList();
    fetchRabs();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  const [rabData, setRabData] = useState<{
    projectId: string,
    rabName: string,
    totalPrice: string,
    file: File | null;
  }>({
    projectId: "",
    rabName: "",
    totalPrice: "0",
    file: null,
  });

  const [errors, setErrors] = useState({
    projectId: false,
    rabName: false,
    totalPrice: false,
  });

  const [openEditRabDialog, setOpenEditRabDialog] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editRabData, setEditRabData] = useState<{
    id: string,
    projectId: string,
    rabName: string,
    totalPrice: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    projectId: "",
    rabName: "",
    totalPrice: "0",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [originalEditRabData, setOriginalEditRabData] = useState<{
    id: string,
    projectId: string,
    rabName: string,
    totalPrice: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    projectId: "",
    rabName: "",
    totalPrice: "0",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [editErrors, setEditErrors] = useState({
    projectId: false,
    rabName: false,
    totalPrice: false,
  });

  const nullAhs = {
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  };

  const [ahsData, setAhsData] = useState<{
    id: string,
    namaAHS: string,
    category: string,
    volume: string,
    satuanAHS: string,
    hargaSatuan: string,
    totalAHS: string,
    totalHarga: string,
  }>({
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  });

  const [rabDetailAdd, setRabDetailAdd] = useState<Array<{
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
  }>>([]);

  const availableAhsOptions = useMemo(() => {
    const usedAhsIds = new Set(rabDetailAdd.map((detail) => detail.ahsId));
    return ahsOptions.filter((ahs) => !usedAhsIds.has(ahs.id));
  }, [ahsOptions, rabDetailAdd]);


  const handleAddAhsToRabDetail = () => {
    if (!ahsData.id || !ahsData.volume || !ahsData.totalHarga) {
      Swal.fire({
        icon: "warning",
        title: "Data AHS belum lengkap",
        text: "Pastikan semua data AHS sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const newDetail = {
      rabId: "", // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: ahsData.id,
      volume: ahsData.volume,
      totalHarga: ahsData.totalHarga.toString(),
      hargaSatuan: ahsData.totalAHS.toString(),
      satuanAHS: ahsData.satuanAHS,
      category: ahsData.category,
      namaAHS: ahsData.namaAHS,
    };

    const updatedDetails = [...rabDetailAdd, newDetail];
    setRabDetailAdd(updatedDetails);

    const ttl = Math.round(
      updatedDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    );
    setTotalRabAdd(ttl);
    console.log("Total RAB setelah update:", ttl);

    setAhsData(nullAhs); // reset form AHS
  };

  const nullRabToSCurve = {
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  };

  const [rabToSCurveAdd, setRabToSCurveAdd] = useState<{
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>({
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  });

  const [sCurveAdd, setSCurveAdd] = useState<Array<{
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);

  const availableDetailOptions = useMemo(() => {
    const usedAhsIds = new Set(sCurveAdd.map((detail) => detail.ahsId));
    return rabDetailAdd.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [rabDetailAdd, sCurveAdd]);

  const handleAddRABToSCurve = () => {
    if (!rabToSCurveAdd.bobotMingguan || !rabToSCurveAdd.durasiMinggu || !rabToSCurveAdd.startDate || !rabToSCurveAdd.endDate) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data sudah terisi sebelum menambahkan ke S-Curves.",
      });
      return;
    }

    const newDetail = {
      rabId: "", // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: rabToSCurveAdd.ahsId,
      rabDetailId: "",
      nilaiPekerjaan: rabToSCurveAdd.nilaiPekerjaan,
      bobot: rabToSCurveAdd.bobot,
      durasiMinggu: rabToSCurveAdd.durasiMinggu,
      bobotMingguan: rabToSCurveAdd.bobotMingguan,
      startDate: rabToSCurveAdd.startDate,
      endDate: rabToSCurveAdd.endDate,
      namaAHS: rabToSCurveAdd.namaAHS,
      category: rabToSCurveAdd.category,
    };

    setSCurveAdd([...sCurveAdd, newDetail]);
    setRabToSCurveAdd(nullRabToSCurve); // reset form RAB
  };


  const [editAhsData, setEditAhsData] = useState<{
    id: string,
    namaAHS: string,
    category: string,
    volume: string,
    satuanAHS: string,
    hargaSatuan: string,
    totalAHS: string,
    totalHarga: string,
  }>({
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  });

  const [rabDetailAddOnEdit, setRabDetailAddOnEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
  }>>([]);

  const [rabDetailOriginalEdit, setRabDetailOriginalEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
  }>>([]);


  const availableAhsOptionsOnEdit = useMemo(() => {
    const usedAhsIds = new Set(rabDetailAddOnEdit.map((detail) => detail.ahsId));
    return ahsOptions.filter((ahs) => !usedAhsIds.has(ahs.id));
  }, [ahsOptions, rabDetailAddOnEdit]);

  const handleAddAhsToRabDetailOnEdit = () => {
    if (!editAhsData.id || !editAhsData.volume || !editAhsData.totalHarga) {
      Swal.fire({
        icon: "warning",
        title: "Data AHS belum lengkap",
        text: "Pastikan semua data AHS sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const newDetail = {
      id: "",
      rabId: editRabData.id, // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: editAhsData.id,
      volume: editAhsData.volume,
      totalHarga: editAhsData.totalHarga.toString(),
      hargaSatuan: editAhsData.totalAHS.toString(),
      satuanAHS: editAhsData.satuanAHS,
      category: editAhsData.category,
      namaAHS: editAhsData.namaAHS,
    };

    const updatedDetails = [...rabDetailAddOnEdit, newDetail];
    const ttl = Math.round(
      updatedDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    );
    setTotalRabEdit(ttl);
    setIsEditedRabDetail(true);
    setRabDetailAddOnEdit(updatedDetails);
    setEditAhsData(nullAhs); // reset form AHS
  };

  const nullRabToSCurveOnEdit = {
    id: "",
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  }

  const [rabToSCurveAddOnEdit, setRabToSCurveAddOnEdit] = useState<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>({
    id: "",
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  });

  const [sCurveAddOnEdit, setSCurveAddOnEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);

  const [sCurveOriginalEdit, setSCurveOriginalEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);


  const availableDetailOptionsOnEdit = useMemo(() => {
    const usedAhsIds = new Set(sCurveAddOnEdit.map((detail) => detail.ahsId));
    return rabDetailAddOnEdit.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [rabDetailAddOnEdit, sCurveAddOnEdit]);

  const handleAddRABToSCurveOnEdit = () => {
    if (!rabToSCurveAddOnEdit.bobotMingguan || !rabToSCurveAddOnEdit.durasiMinggu || !rabToSCurveAddOnEdit.startDate || !rabToSCurveAddOnEdit.endDate) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data sudah terisi sebelum menambahkan ke S-Curves.",
      });
      return;
    }

    const newDetail = {
      id: "",
      rabId: editRabData.id, // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: rabToSCurveAddOnEdit.ahsId,
      rabDetailId: "",
      nilaiPekerjaan: rabToSCurveAddOnEdit.nilaiPekerjaan,
      bobot: rabToSCurveAddOnEdit.bobot,
      durasiMinggu: rabToSCurveAddOnEdit.durasiMinggu,
      bobotMingguan: rabToSCurveAddOnEdit.bobotMingguan,
      startDate: rabToSCurveAddOnEdit.startDate,
      endDate: rabToSCurveAddOnEdit.endDate,
      namaAHS: rabToSCurveAddOnEdit.namaAHS,
      category: rabToSCurveAddOnEdit.category,
    };

    setSCurveAddOnEdit([...sCurveAddOnEdit, newDetail]);
    setIsEditedSCurve(true);
    setRabToSCurveAddOnEdit({ id: "", ...nullRabToSCurve }); // reset form RAB
  };


  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setRabData({ ...rabData, file });
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditRabData({ ...editRabData, file });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRabData({ ...rabData, [name]: value });
  };

  const handleProjectChange = (e) => {
    if (e.target.value == '') {
      setProjectAdd(nullProject);
    } else {
      const selectedProject = projectOptions.find(proj => proj.id == e.target.value);
      setProjectAdd(selectedProject);
    }
    setRabData({ ...rabData, projectId: e.target.value });
  };

  const handleAhsChange = (e) => {
    if (e.target.value == '') {
      setAhsData(nullAhs);
    } else {
      const selectedAhs = ahsOptions.find(ahs => ahs.id == e.target.value);
      setAhsData(selectedAhs);
    }

    // setRabData({ ...rabData, projectId: e.target.value });
  };

  const handleDetailChange = (e) => {
    if (e.target.value == '') {
      setRabToSCurveAdd(nullRabToSCurve);
    } else {
      const selectedRabDetail = rabDetailAdd.find(detail => detail.ahsId == e.target.value);
      const bobot = (selectedRabDetail?.totalHarga / totalRabAdd);
      setRabToSCurveAdd({ ...selectedRabDetail, nilaiPekerjaan: selectedRabDetail?.totalHarga, bobot: bobot.toString() });
    }

    // setRabData({ ...rabData, projectId: e.target.value });
  };

  const handleSCurveInputChange = (e) => {
    const { name, value } = e.target;
    setRabToSCurveAdd({ ...rabToSCurveAdd, [name]: value });
  };

  const handleInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setEditRabData({ ...editRabData, [name]: value });
  };

  const handleProjectChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setProjectEdit(nullProject);
    } else {
      const selectedProject = projectOptions.find(proj => proj.id == e.target.value);
      setProjectEdit(selectedProject);
    }
    setEditRabData({ ...editRabData, projectId: e.target.value });
  };

  const handleAhsChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setEditAhsData(nullAhs);
    } else {
      const selectedAhs = ahsOptions.find(ahs => ahs.id == e.target.value);
      setEditAhsData(selectedAhs);
    }

    // setRabData({ ...rabData, projectId: e.target.value });
  };

  const handleDetailChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setRabToSCurveAddOnEdit(nullRabToSCurveOnEdit);
    } else {
      const selectedRabDetail = rabDetailAddOnEdit.find(detail => detail.ahsId == e.target.value);

      const bobot = (selectedRabDetail?.totalHarga / totalRabEdit);
      setRabToSCurveAddOnEdit({ ...selectedRabDetail, nilaiPekerjaan: selectedRabDetail?.totalHarga, bobot: bobot.toString() });
    }

    // setRabData({ ...rabData, projectId: e.target.value });
  };

  const handleSCurveInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setRabToSCurveAddOnEdit({ ...rabToSCurveAddOnEdit, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      projectId: !rabData.projectId,
      rabName: !rabData.rabName,
      // totalPrice: !rabData.totalPrice,
      totalPrice: false,
    };

    console.log(newErrors)

    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      projectId: !editRabData.projectId,
      rabName: !editRabData.rabName,
      // totalPrice: !editRabData.totalPrice,
      totalPrice: false,
    };

    setEditErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const errorResponse = (title, error) => {
    let errorTitle = "";
    let errorDetails = "";

    // Handle backend error response
    if (error.response?.data) {
      const backendError = error.response.data;

      // Debug log untuk melihat struktur error
      console.log(
        "Backend Error Structure:",
        JSON.stringify(backendError, null, 2)
      );

      // Main error message
      errorTitle = backendError.error || errorTitle;

      // Handle all possible email validation error formats - PERBAIKAN UTAMA
      const isEmailValidationError =
        // Case 1: Error in details (Sequelize style)
        (backendError.details &&
          /validation isEmail on (email|projectEmail)/i.test(
            backendError.details
          )) ||
        // Case 2: Error in errors array (Sequelize validation errors)
        (backendError.errors &&
          backendError.errors.some(
            (err: any) =>
              (err.path === "email" || err.path === "projectEmail") &&
              err.validatorKey === "isEmail"
          )) ||
        // Case 3: Error in message (generic API responses)
        (backendError.message &&
          /email.*invalid/i.test(backendError.message));

      if (isEmailValidationError) {
        errorTitle = "Format Email Tidak Valid";
        errorDetails =
          "• Format email tidak valid (contoh: nama@perusahaan.com)";
      }
      // Only use details if not an email error
      else if (backendError.details) {
        errorDetails = backendError.details;
      }

      // Handle validation errors (improved processing)
      if (backendError.errors) {
        const validationMessages = backendError.errors
          .map((err: any) => {
            // Handle both array and object error formats
            const errorObj = Array.isArray(err) ? err[0] : err;

            // Skip email errors since we already handled them
            if (
              (errorObj.path === "email" ||
                errorObj.path === "projectEmail") &&
              errorObj.validatorKey === "isEmail"
            ) {
              return null;
            }
            return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
          })
          .filter(Boolean) // Remove null entries
          .join("\n");

        if (validationMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }
      }

      // Handle duplicate fields (improved formatting)
      if (backendError.duplicates) {
        const duplicateMessages = backendError.duplicates
          .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
          .join("\n");

        if (duplicateMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
    }
    // Handle network or other errors
    else {
      errorDetails =
        error.message || "Terjadi kesalahan jaringan atau server";
    }

    // Show error in Swal (improved formatting)
    Swal.fire({
      icon: "error",
      title: title,
      html: `
                <div style="text-align: left;">
                  <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
                    ${errorTitle}
                  </p>
                  ${errorDetails
          ? `<div style="
                          color: #5f2120;
                          background: #fdecea;
                          padding: 12px;
                          border-radius: 4px;
                          font-size: 0.9em;
                          border-left: 4px solid #d32f2f;
                          line-height: 1.5;
                        ">
                          ${errorDetails.replace(/\n/g, "<br>")}
                        </div>`
          : ""
        }
                </div>
              `,
      confirmButtonColor: "#0F62FE",
      width: "600px",
    });
  }


  const handleSubmitAddRab = async () => {
    if (rabDetailAdd.length > sCurveAdd.length) {
      return showPopupMandatoryError("Lengkapi S-Curve untuk semua RAB Detail."); // Penting: pakai return!
    }

    if (!validateForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      console.log(rabData);

      const rabSumTotal = { ...rabData, totalPrice: Math.round(totalRabAdd * 1.11) }

      // Step 1: Create RAB
      const newRab = await createRab(rabSumTotal);

      if (!newRab?.id) throw new Error("Gagal membuat RAB");

      const updatedRabDetails = rabDetailAdd.map((detail) => ({
        ...detail,
        rabId: newRab.id,
      }));

      const failedDetails: string[] = [];
      const failedSCurves: string[] = [];

      // Step 2: Loop create RabDetail dan SCurve
      for (const detail of updatedRabDetails) {
        try {
          const newRabDetail = await createRabDetail(detail);

          if (!newRabDetail?.id) throw new Error("Gagal simpan detail");

          const updatedSCurveAdd = sCurveAdd.find(
            (scurve) => scurve.ahsId === newRabDetail.ahsId
          );

          if (updatedSCurveAdd) {
            updatedSCurveAdd.rabDetailId = newRabDetail.id;
            updatedSCurveAdd.rabId = newRab.id;

            try {
              await createSCurve(updatedSCurveAdd);
            } catch (err) {
              console.error("Gagal menyimpan SCurve:", updatedSCurveAdd, err);
              failedSCurves.push(detail.namaAHS);
            }
          } else {
            console.warn("SCurve tidak ditemukan untuk ahsId:", newRabDetail.ahsId);
          }
        } catch (err) {
          console.error("Gagal menyimpan RAB Detail:", detail, err);
          failedDetails.push(detail.namaAHS);
        }
      }

      // Show error jika ada yang gagal
      if (failedDetails.length || failedSCurves.length) {
        const errorText = [
          failedDetails.length && `RAB Detail gagal: ${failedDetails.join(", ")}`,
          failedSCurves.length && `SCurve gagal: ${failedSCurves.join(", ")}`,
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "RAB berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenAddRabDialog(false);
      setTotalRabAdd(0);
      setRabDetailAdd([]);
      setSCurveAdd([]);
      setRabData({
        projectId: "",
        rabName: "",
        totalPrice: "0",
        file: null,
      });
      await fetchRabs();
    } catch (error: any) {
      await errorResponse("Gagal membuat RAB", error);
    }
  };

  const handleSubmitEditRab = async () => {
    if (rabDetailAddOnEdit.length > sCurveAddOnEdit.length) {
      return showPopupMandatoryError("Lengkapi S-Curve untuk semua RAB Detail."); // Penting: pakai return!
    }

    if (!validateEditForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      console.log(editRabData);

      // Hitung ulang total setelah penghapusan
      const newTotal = Math.round(
        rabDetailAddOnEdit.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
      );
      console.log(totalRabEdit,newTotal);

      const rabSumTotal = { ...editRabData, totalPrice: Math.round(totalRabEdit * 1.11) }

      // Step 1: Create RAB
      const newRab = await editRab(rabSumTotal);


      if (!newRab?.id) throw new Error("Gagal mengupdate RAB");
      console.log("editRAB", newRab);

      const failedDetails: string[] = [];
      const failedSCurves: string[] = [];

      if (isEditedRabDetail || isEditedSCurve) {
        await rabDetailOriginalEdit.map(async (detail) => (await deleteRabDetail(detail.id)));

        const updatedRabDetails = await rabDetailAddOnEdit.map((detail) => ({
          ...detail,
          rabId: newRab.id,
          id: undefined,
        }));

        // Step 2: Loop create RabDetail dan SCurve
        for (const detail of updatedRabDetails) {
          try {
            const newRabDetail = await createRabDetail(detail);

            if (!newRabDetail?.id) throw new Error("Gagal simpan detail");

            const updatedSCurveAdd = sCurveAddOnEdit.find(
              (scurve) => scurve.ahsId === newRabDetail.ahsId
            );

            if (updatedSCurveAdd) {
              updatedSCurveAdd.rabDetailId = newRabDetail.id;
              updatedSCurveAdd.rabId = newRab.id;

              try {
                await createSCurve({ ...updatedSCurveAdd, id: undefined, });
              } catch (err) {
                console.error("Gagal menyimpan SCurve:", updatedSCurveAdd, err);
                failedSCurves.push(detail.namaAHS);
              }
            } else {
              console.warn("SCurve tidak ditemukan untuk ahsId:", newRabDetail.ahsId);
            }
          } catch (err) {
            console.error("Gagal menyimpan RAB Detail:", detail, err);
            failedDetails.push(detail.namaAHS);
          }
        }
      }


      // Show error jika ada yang gagal
      if (failedDetails.length || failedSCurves.length) {
        const errorText = [
          failedDetails.length && `RAB Detail gagal: ${failedDetails.join(", ")}`,
          failedSCurves.length && `SCurve gagal: ${failedSCurves.join(", ")}`,
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "RAB berhasil disimpan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenEditRabDialog(false);
      setTotalRabEdit(0);
      setRabDetailAddOnEdit([]);
      setSCurveAddOnEdit([]);
      setEditRabData({
        id: "",
        projectId: "",
        rabName: "",
        totalPrice: "0",
        file: null,
        salesProjectImage: "",
        previewUrl: "",
      });
      setIsEditedRabDetail(false);
      setIsEditedSCurve(false);
      await fetchRabs();
    } catch (error: any) {
      await errorResponse("Gagal mengupdate RAB", error);
    }
  };

  const handleOpenEditRab = async (rab) => {

    const rabDetail = await getRabDetail({ limit: 1000000, rabId: rab.id });
    const rabDetailWithAHS = rabDetail.data.map(rab => {
      // const ahsDetail = ahsOptions.find((ahs) => ahs.id === rab.ahsId);
      const ahsDetail = rab.ahs;
      rab.category = ahsDetail.category;
      rab.hargaSatuan = ahsDetail.totalAHS;
      rab.satuanAHS = ahsDetail.satuanAHS;
      rab.namaAHS = ahsDetail.namaAHS;
      return rab;
    })
    const sCurve = await getSCurve({ limit: 1000000, rabId: rab.id });
    console.log("SC", sCurve.data);
    const sCurveWithAHS = sCurve.data.map(sc => {
      const ahsDetail = ahsOptions.find((ahs) => ahs.id === sc.rabDetail.ahsId);
      console.log("AHS DETAIL", ahsDetail);
      sc.ahsId = ahsDetail.id;
      sc.category = ahsDetail.category;
      sc.hargaSatuan = ahsDetail.totalAHS;
      sc.satuanAHS = ahsDetail.satuanAHS;
      sc.namaAHS = ahsDetail.namaAHS;
      return sc;
    })
    await console.log(rabDetailWithAHS, sCurveWithAHS);
    await setProjectEdit(rab.project);

    await setRabDetailAddOnEdit(rabDetailWithAHS);
    await setSCurveAddOnEdit(sCurveWithAHS);

    setIsEditedRabDetail(false);
    setIsEditedSCurve(false);

    await setEditRabData({
      ...rab,
      file: null,
    });
    await console.log(rab, editRabData);

    // Hitung ulang total setelah penghapusan
    const newTotal = Math.round(
      rabDetailWithAHS.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    );
    setTotalRabEdit(newTotal);
    await setOriginalEditRabData(rab); // Simpan nilai asli untuk tombol cancel
    await setRabDetailOriginalEdit(rabDetailWithAHS);
    await setSCurveOriginalEdit(sCurveWithAHS);
    await setIsEditing(false); // Kunci form sampai tombol edit diklik
    const { from, to } = getTimeRangeFromScurve(sCurveWithAHS);
    await setIfFrom(from);
    await setIfTo(to);
    await setOpenEditRabDialog(true);

  };

  const handleDeleteRabDetailRow = (indexToRemove: number) => {
    const ahsIdToRemove = rabDetailAdd[indexToRemove].ahsId;

    // Hapus baris dari rabDetailAdd
    const updatedRabDetails = rabDetailAdd.filter((_, idx) => idx !== indexToRemove);
    setRabDetailAdd(updatedRabDetails);

    // Hitung ulang total setelah penghapusan
    const newTotal = Math.round(
      updatedRabDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    );
    setTotalRabAdd(newTotal);

    // Hapus entri yang punya ahsId yang sama dari sCurveAdd
    const updatedSCurves = sCurveAdd.filter((scurve) => scurve.ahsId !== ahsIdToRemove);
    setSCurveAdd(updatedSCurves);
    setIsEditedRabDetail(true);
  };

  const handleDeleteRabDetailEdit = (indexToRemove: number) => {
    const ahsIdToRemove = rabDetailAddOnEdit[indexToRemove].ahsId;

    // Hapus baris dari rabDetailAdd
    const updatedRabDetails = rabDetailAddOnEdit.filter((_, idx) => idx !== indexToRemove);
    setRabDetailAddOnEdit(updatedRabDetails);

    // Hitung ulang total setelah penghapusan
    const newTotal = Math.round(
      updatedRabDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    );
    setTotalRabEdit(newTotal);

    // Hapus entri yang punya ahsId yang sama dari sCurveAdd
    const updatedSCurves = sCurveAddOnEdit.filter((scurve) => scurve.ahsId !== ahsIdToRemove);
    setSCurveAddOnEdit(updatedSCurves);
  };


  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        const deletedRab = await deleteRab(id);

      }));

      Swal.fire({
        icon: "success",
        title: "Rab berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchRabs(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditRab = () => {
    setEditRabData(originalEditRabData); // Kembalikan nilai asli
    setIsEditing(false); // Kunci kembali form
    setOpenEditRabDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
    const name = filters[index].field;
    if (name === "startDate") { setStartDateS(null); setEndDateS(null); }
    if (name === "endDate") { setStartDateE(null); setEndDateE(null); }
    if (name === "valueEstimation") { setValueMin(""); setValueMax(""); }
    console.log(filters, startDateS, endDateS)
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `RABSearchParams`
      const searchParams: RABSearchParams = {};

      if (startDateS && endDateS) {
        if (startDateS === endDateS) {
          searchParams.startDate = await startDateS;
        } else {
          searchParams.startDateS = await startDateS;
          searchParams.endDateS = await endDateS;
        }
      }

      if (startDateS && !endDateS) {
        searchParams.startDate = await startDateS;
      }

      if (startDateE && endDateE) {
        if (startDateE === endDateE) {
          searchParams.endDate = await startDateE;
        } else {
          searchParams.startDateE = await startDateE;
          searchParams.endDateE = await endDateE;
        }
      }

      if (startDateE && !endDateE) {
        searchParams.endDate = await startDateE;
      }

      if (valueMin && valueMax) {
        if (valueMin === valueMax) {
          searchParams.valueEstimation = await valueMin;
        } else {
          searchParams.valueMin = await valueMin;
          searchParams.valueMax = await valueMax;
        }
      }

      if (valueMin && !valueMax) {
        searchParams.valueEstimation = await valueMin;
      }

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getRab(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
    setStartDateS(null);
    setEndDateS(null);
    setStartDateE(null);
    setEndDateE(null);
    setValueMin("");
    setValueMax("");
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getRab({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Rab");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Rabs_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export rab data',
      });
    }
  };

  const getTimeRangeFromScurve = (scurveAddOnEdit: any[]) => {
    if (!scurveAddOnEdit.length) return { from: "", to: "" };

    const startDates = scurveAddOnEdit.map((item) => new Date(item.startDate));
    const endDates = scurveAddOnEdit.map((item) => new Date(item.endDate));

    const earliestStart = new Date(Math.min(...startDates.map(d => d.getTime())));
    const latestEnd = new Date(Math.max(...endDates.map(d => d.getTime())));

    return {
      from: earliestStart.getTime().toString(),
      to: latestEnd.getTime().toString(),
    };
  };

  const [ifFrom, setIfFrom] = useState("");
  const [ifTo, setIfTo] = useState("");




  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allRabs = await getRab({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allRabs.data.map(rab => ({
      'Project Name': rab.rabName,
      'Source': rab.projectEmail,
      'Kode Project': rab.projectAddress,
      'Longitude': rab.longitude,
      'Latitude': rab.latitude,
      'Region': rab.region,
      'City': rab.city,
      'District': rab.district,
      'Project Type': rab.projectType,
      'Project Phase': rab.constructionPhase,
      'Start Date': rab.startDate,
      'End Date': rab.endDate,
      'Value Estimation': Number(rab.valueEstimation),
    }));
  };

  const exportRabDetailToPDF = async () => {
    try {
      const doc = new jsPDF();

      // 1. Add header image
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", -10, 0, 230, 40);
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      // Add horizontal line after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 37, 200, 37);

      // 2. Main content
      const startY = 60;
      doc.setFontSize(18);
      const titleText = `RAB: ${editRabData.rabName || "-"}`;
      const wrappedTitle = doc.splitTextToSize(titleText, 170);
      doc.text(wrappedTitle, 105, startY - 15, { align: "center" });

      // ===== PROJECT INFORMATION TABLE =====
      doc.setFontSize(12);
      doc.text("Project Information", 15, startY + 2);

      const project = projectOptions.find(pro => pro.id === editRabData.projectId) || {};

      autoTable(doc, {
        head: [["Name", "Description"]],
        body: [
          ["Project Name", project.projectName || "-"],
          ["Project Code", project.projectReferenceId || "-"],
          ["Project Type", project.projectType || "-"],
          ["Value Estimation", `Rp ${Number(project.valueEstimation || 0).toLocaleString("id-ID")}`],
          ["Project Address", project.projectAddress || "-"],
          ["Source", project.source || "-"],
          ["Construction Phase", project.constructionPhase || "-"],
          ["Start Date", project.startDate || "-"],
          ["End Date", project.endDate || "-"],
          ["Latitude", project.latitude || "-"],
          ["Longitude", project.longitude || "-"]
        ],
        startY: startY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 3,
          fontSize: 8,
        },
        columnStyles: {
          0: { cellWidth: 60, fontStyle: "bold" },
          1: { cellWidth: 120 }
        },
        didDrawCell: (data) => {
          // Add small separator lines between rows
          if (data.section === 'body' && data.row.index > 0) {
            doc.setDrawColor(200, 200, 200);
            doc.setLineWidth(0.2);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height - 2,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height - 2
            );
          }
        }
      });

      // ===== RAB DETAILS TABLE =====
      const rabStartY = (doc as any).lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.text("RAB Details", 15, rabStartY);

      autoTable(doc, {
        head: [
          [
            "No",
            "Category",
            "Description",
            "Volume",
            "Unit",
            "Unit Price",
            "Total Price",
          ],
        ],
        body: rabDetailAddOnEdit.map((item, i) => [
          `${i + 1}`,
          item.category || "-",
          item.namaAHS || "-",
          item.volume || "-",
          item.satuanAHS || "-",
          { content: `Rp ${Math.round(Number(item.hargaSatuan)).toLocaleString("id-ID")}` || "-", styles: { halign: "right" } },
          { content: `Rp ${Math.round(Number(item.totalHarga)).toLocaleString("id-ID")}` || "-", styles: { halign: "right" } },
        ]),
        foot: [
          [
            { content: "Jumlah", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
            `Rp ${(totalRabEdit).toLocaleString("id-ID")}`
          ],
          [
            { content: "PPN 11%", colSpan: 6, styles: { halign: "right" } },
            `Rp ${Math.round(totalRabEdit * 0.11).toLocaleString("id-ID")}`
          ],
          [
            { content: "Total", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
            `Rp ${Math.round(totalRabEdit * 1.11).toLocaleString("id-ID")}`
          ]
        ],
        footStyles: {
          fillColor: [230, 230, 230],
          fontSize: 8,
          textColor: [0, 0, 0],
          halign: "right",
        },
        startY: rabStartY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 8,
        },
        columnStyles: {
          4: { cellWidth: "auto", minCellHeight: 10 },
        },
      });

      // ===== SUMMARY SECTION =====
      const summaryStartY = (doc as any).lastAutoTable.finalY + 10;

      // Calculate column positions
      const labelCol = 130;  // Right-aligned labels
      const valueCol = 180;  // Right-aligned values

      // Amount in words
      doc.setFontSize(9);
      const amountText = `Terbilang: ${terbilang(Math.round(totalRabEdit * 1.11))} Rupiah`;
      doc.text(amountText, 15, summaryStartY, { maxWidth: 180 });

      // Footer
      // doc.setFontSize(8);
      // doc.setTextColor(100);
      // doc.text("Generated by RAB System", 105, 285, { align: "center" });
      // doc.text(new Date().toLocaleString(), 105, 290, { align: "center" });

      // 3. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      doc.save(`RAB_${editRabData.rabName || "new"}_${date}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportRabDetailToExcel = async () => {
    try {
      // Prepare data for Excel export
      const project = projectOptions.find(pro => pro.id === editRabData.projectId) || {};

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 2. Create Project Information sheet
      const projectInfoData = [
        ["RAB Name", editRabData.rabName || "-"],
        ["Project Name", project.projectName || "-"],
        ["Project Code", project.projectReferenceId || "-"],
        ["Project Type", project.projectType || "-"],
        ["Value Estimation", `${Number(project.valueEstimation || 0)}`],
        ["Project Address", project.projectAddress || "-"],
        ["Source", project.source || "-"],
        ["Construction Phase", project.constructionPhase || "-"],
        ["Start Date", project.startDate || "-"],
        ["End Date", project.endDate || "-"],
        ["Latitude", project.latitude || "-"],
        ["Longitude", project.longitude || "-"]
      ];

      const projectInfoWs = XLSX.utils.aoa_to_sheet([
        ["PROJECT INFORMATION"],
        [], // empty row
        ...projectInfoData
      ]);

      // 3. Create RAB Details sheet
      const rabDetailsHeader = [
        "No",
        "Category",
        "Description",
        "Volume",
        "Unit",
        "Unit Price",
        "Total Price"
      ];

      const rabDetailsData = rabDetailAddOnEdit.map((item, index) => [
        index + 1,
        item.category || "-",
        item.namaAHS || "-",
        item.volume || "-",
        item.satuanAHS || "-",
        `${Math.round(Number(item.hargaSatuan))}`,
        `${Math.round(Number(item.totalHarga))}`
      ]);

      const rabDetailsWs = XLSX.utils.aoa_to_sheet([
        ["RAB DETAILS"],
        [], // empty row
        rabDetailsHeader,
        ...rabDetailsData,
        [], // empty row
        ["Subtotal:", "", "", "", "", "", `${totalRabEdit}`],
        ["Tax (11%):", "", "", "", "", "", `${Math.round(totalRabEdit * 0.11)}`],
        ["Total:", "", "", "", "", "", `${Math.round(totalRabEdit * 1.11)}`],
        [], // empty row
        ["Amount in words:", terbilang(Math.round(totalRabEdit * 1.11)) + " Rupiah"]
      ]);

      // 4. Formatting and styling
      // Project Info sheet formatting
      projectInfoWs["!cols"] = [
        { wch: 20 }, // Column A width
        { wch: 40 }  // Column B width
      ];

      // RAB Details sheet formatting
      rabDetailsWs["!cols"] = [
        { wch: 5 },  // No
        { wch: 25 }, // Category
        { wch: 35 }, // Description
        { wch: 10 }, // Volume
        { wch: 10 }, // Unit
        { wch: 15 }, // Unit Price
        { wch: 15 }  // Total Price
      ];

      // Merge title cells
      projectInfoWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } } // Merge PROJECT INFORMATION title
      ];

      rabDetailsWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge RAB DETAILS title
        { s: { r: rabDetailsData.length + 3, c: 0 }, e: { r: rabDetailsData.length + 3, c: 6 } }, // Merge amount in words
        { s: { r: rabDetailsData.length + 4, c: 0 }, e: { r: rabDetailsData.length + 4, c: 6 } } // Merge amount in words value
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, projectInfoWs, "Project Info");
      XLSX.utils.book_append_sheet(wb, rabDetailsWs, "RAB Details");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `RAB_Details_${editRabData.rabName || "export"}_${date}.xlsx`);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  const exportSCurveToPDF = async () => {
    try {
      const doc = new jsPDF();

      // === Header ===
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", -10, 0, 230, 40);
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 37, 200, 37);

      const startY = 60;
      doc.setFontSize(18);
      const titleText = `RAB: ${editRabData.rabName || "-"}`;
      const wrappedTitle = doc.splitTextToSize(titleText, 170);
      doc.text(wrappedTitle, 105, startY - 15, { align: "center" });

      // === Project Info Table ===
      doc.setFontSize(12);
      doc.text("Project Information", 15, startY + 2);
      const project = projectOptions.find(pro => pro.id === editRabData.projectId) || {};

      autoTable(doc, {
        head: [["Name", "Description"]],
        body: [
          ["Project Name", project.projectName || "-"],
          ["Project Code", project.projectReferenceId || "-"],
          ["Project Type", project.projectType || "-"],
          ["Value Estimation", `Rp ${Number(project.valueEstimation || 0).toLocaleString("id-ID")}`],
          ["Project Address", project.projectAddress || "-"],
          ["Source", project.source || "-"],
          ["Construction Phase", project.constructionPhase || "-"],
          ["Start Date", project.startDate || "-"],
          ["End Date", project.endDate || "-"],
          ["Latitude", project.latitude || "-"],
          ["Longitude", project.longitude || "-"]
        ],
        startY: startY + 5,
        margin: { left: 15 },
        headStyles: { fillColor: [169, 169, 169], textColor: 255, fontStyle: "bold" },
        styles: { cellPadding: 3, fontSize: 8 },
        columnStyles: { 0: { cellWidth: 60, fontStyle: "bold" }, 1: { cellWidth: 120 } }
      });

      // === SCurve Table ===
      const tableStartY = (doc as any).lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.text("SCurve Details", 15, tableStartY);

      autoTable(doc, {
        head: [[
          "No", "Category", "Description", "Nilai Pekerjaan", "Bobot",
          "Bobot Mingguan", "Total Durasi", "Start", "End"
        ]],
        body: sCurveAddOnEdit.map((item, i) => [
          `${i + 1}`,
          item.category || "-",
          item.namaAHS || "-",
          { content: `Rp ${Math.round(Number(item.nilaiPekerjaan)).toLocaleString("id-ID")}` || "-", styles: { halign: "right" } },
          item.bobot || "-",
          item.bobotMingguan || "-",
          item.durasiMinggu || "-",
          item.startDate || "-",
          item.endDate || "-"
        ]),
        startY: tableStartY + 5,
        margin: { left: 15 },
        headStyles: { fillColor: [100, 100, 100], textColor: 255, fontStyle: "bold" },
        styles: { cellPadding: 2, fontSize: 8 },
        columnStyles: { 4: { cellWidth: "auto", minCellHeight: 10 } }
      });

      // === Screenshot Grafana Chart (html2canvas) ===
      const chartStartY = (doc as any).lastAutoTable.finalY + 10;
      if (grafanaChartRef.current) {
        const canvas = await html2canvas(grafanaChartRef.current, {
          scale: 2,
          useCORS: true,
        });
        const imageData = canvas.toDataURL("image/png");

        doc.addPage();
        doc.setFontSize(14);
        doc.text("Grafik SCurve", 15, 20);
        doc.addImage(imageData, "PNG", 15, 30, 180, 90);
      } else {
        console.warn("grafanaChartRef not found");
      }

      // === Save PDF ===
      const date = new Date().toISOString().slice(0, 10);
      doc.save(`SCurve_${editRabData.rabName || "new"}_${date}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportSCurveToExcel = async () => {
    try {
      // Prepare data for Excel export
      const project = projectOptions.find(pro => pro.id === editRabData.projectId) || {};

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 2. Create Project Information sheet
      const projectInfoData = [
        ["RAB Name", editRabData.rabName || "-"],
        ["Project Name", project.projectName || "-"],
        ["Project Code", project.projectReferenceId || "-"],
        ["Project Type", project.projectType || "-"],
        ["Value Estimation", `${Number(project.valueEstimation || 0)}`],
        ["Project Address", project.projectAddress || "-"],
        ["Source", project.source || "-"],
        ["Construction Phase", project.constructionPhase || "-"],
        ["Start Date", project.startDate || "-"],
        ["End Date", project.endDate || "-"],
        ["Latitude", project.latitude || "-"],
        ["Longitude", project.longitude || "-"]
      ];

      const projectInfoWs = XLSX.utils.aoa_to_sheet([
        ["PROJECT INFORMATION"],
        [], // empty row
        ...projectInfoData
      ]);

      // 3. Create RAB Details sheet
      const sCurvesHeader = [
        "No",
        "Category",
        "Description",
        "Nilai Pekerjaan",
        "Bobot",
        "Bobot Mingguan",
        "Total Durasi",
        "Start",
        "End",
      ];

      const sCurvesData = sCurveAddOnEdit.map((item, index) => [
        index + 1,
        item.category || "-",
        item.namaAHS || "-",
        { content: `Rp ${Math.round(Number(item.nilaiPekerjaan))}` || "-", styles: { halign: "right" } },
        item.bobot || "-",
        item.bobotMingguan || "-",
        item.durasiMinggu || "-",
        item.startDate || "-",
        item.endDate || "-",
      ]);

      const sCurvesWs = XLSX.utils.aoa_to_sheet([
        ["SCurve"],
        [], // empty row
        sCurvesHeader,
        ...sCurvesData,
        [], // empty row

      ]);

      // 4. Formatting and styling
      // Project Info sheet formatting
      projectInfoWs["!cols"] = [
        { wch: 20 }, // Column A width
        { wch: 40 }  // Column B width
      ];

      // RAB Details sheet formatting
      sCurvesWs["!cols"] = [
        { wch: 5 },  // No
        { wch: 20 }, // Category
        { wch: 25 }, // Description
        { wch: 5 }, // Volume
        { wch: 5 }, // Unit
        { wch: 15 }, // Unit Price
        { wch: 15 },  // Total Price
        { wch: 15 }, // Unit Price
      ];

      // Merge title cells
      projectInfoWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } } // Merge PROJECT INFORMATION title
      ];

      sCurvesWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge RAB DETAILS title
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, projectInfoWs, "Project Info");
      XLSX.utils.book_append_sheet(wb, sCurvesWs, "SCurve");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `SCurve_${editRabData.rabName || "export"}_${date}.xlsx`);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  return (
    isLoading ? <LoadingOverlay /> :
      <Box sx={{ padding: 3 }}>
        {/* Header & Tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            RAB List
          </Typography>
        </Box>

        {/* Toolbar */}
        <Box className="toolbar">
          {/* Left Controls */}
          <Box className="leftControls">
            <Typography>Show</Typography>
            <Select value={rowsPerPage} onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }} size="small">
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>

            {/* Search Button & Input */}
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={() => setShowSearch((prev) => !prev)}
              className="searchButton"
            >
              Search
            </Button>
            {showSearch && (
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={async (e) => {
                  await setSearchQuery(e.target.value);
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
                autoFocus
                className="searchInput"
              />
            )}

            {/* Menampilkan Error */}
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Box>

          {/* Right Controls */}
          <Box className="rightControls">
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => {
                const selectedData = rows.filter((row) => selectedRows.includes(row.rabid));
                setItemsToDelete(selectedData);
                setOpenDeleteDialog(true);
              }}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
            {/* Filter Button */}
            <Button
              startIcon={<FilterList />}
              variant="text"
              onClick={() => setOpenFilterDialog(true)}
            >
              Filters
            </Button>
            {/* <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
              Export
            </Button> */}
            <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => { setOpenAddRabDialog(true) }}>
              Add New Rab
            </Button>
          </Box>
        </Box>


        {/* Delete Button & Subtitle */}

        <Box className="deleteContainer">
          <Typography variant="body2" className="detailsSubtitle">
            Details List Of All RAB
          </Typography>
        </Box>


        {/* Table */}
        <TableContainer component={Paper} className="tableContainer">
          <Table className="table">
            <TableHead className="tableHead">
              <TableRow>
                {/* Checkbox header */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={selectedRows.length === rows.length}
                    onChange={() =>
                      setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                    }
                  />
                </TableCell>
                <TableCell>No</TableCell>
                {/* Header dengan sorting */}
                <TableCell className="tableCell" onClick={() => handleSort("rabName")} style={{ cursor: "pointer" }}>
                  <strong>RAB Name</strong>
                  {sortConfig.orderBy === "rabName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectName")} style={{ cursor: "pointer" }}>
                  <strong>Project Name</strong>
                  {sortConfig.orderBy === "projectName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectEmail")} style={{ cursor: "pointer" }}>
                  <strong>Source</strong>
                  {sortConfig.orderBy === "projectEmail" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectAddress")} style={{ cursor: "pointer" }}>
                  <strong>Kode Project</strong>
                  {sortConfig.orderBy === "projectAddress" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("managerName")} style={{ cursor: "pointer" }}>
                  <strong>Region</strong>
                  {sortConfig.orderBy === "managerName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("totalPrice")} style={{ cursor: "pointer" }}>
                  <strong>RAB Value</strong>
                  {sortConfig.orderBy === "totalPrice" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectType")} style={{ cursor: "pointer" }}>
                  <strong>Project Type</strong>
                  {sortConfig.orderBy === "projectType" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("constructionPhase")} style={{ cursor: "pointer" }}>
                  <strong>Project Phase</strong>
                  {sortConfig.orderBy === "constructionPhase" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("startDate")} style={{ cursor: "pointer" }}>
                  <strong>Start Date</strong>
                  {sortConfig.orderBy === "startDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("endDate")} style={{ cursor: "pointer" }}>
                  <strong>End Date</strong>
                  {sortConfig.orderBy === "endDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell">
                </TableCell> {/* Kolom untuk aksi */}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedRows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  {/* Checkbox */}
                  <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  {/* Data */}
                  <TableCell className="tableCell" title={row.rabName}><strong>{row.rabName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.project.projectName}><strong>{row.project.projectName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.project.source}>{row.project.source}</TableCell>
                  <TableCell className="tableCell" title={row.project.projectReferenceId}>{row.project.projectReferenceId}</TableCell>
                  <TableCell className="tableCell" title={row.project.region}>{row.project.region}</TableCell>
                  <TableCell className="tableCell" title={row.totalPrice}>Rp {Number(row.totalPrice).toLocaleString("id-ID")}</TableCell>
                  <TableCell className="tableCell" title={row.project.projectType}>{row.project.projectType}</TableCell>
                  <TableCell className="tableCell" title={row.project.constructionPhase}>{row.project.constructionPhase}</TableCell>
                  <TableCell className="tableCell" title={row.project.startDate}>{row.project.startDate}</TableCell>
                  <TableCell className="tableCell" title={row.project.endDate}>{row.project.endDate}</TableCell>
                  {/* Status Badge */}
                  {/* <TableCell className="tableCell" title={row.projectType}>
                    <Box className="statusBadge" style={{ backgroundColor: projectTypeColors[row.projectType] ? projectTypeColors[row.projectType] : "grey" }}>
                      {row.projectType}
                    </Box>
                  </TableCell> */}
                  {/* Ikon More Options */}
                  {/* Ikon More Options */}
                  <TableCell className="tableCell">
                    <IconButton onClick={() => { setTotalRabEdit(0); handleOpenEditRab(row) }}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>


        {/* Pagination */}
        <Box
          className="paginationContainer"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "16px 0",
          }}
        >
          {/* Info jumlah data */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`Showing ${offset + 1} to ${Math.min(
              offset + rowsPerPage,
              totalItems
            )} of ${totalItems} entries`}
          </Typography>

          {/* Komponen Pagination */}
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => setCurrentPage(page)}
            className="pagination"
            showFirstButton
            showLastButton
            renderItem={(item) => (
              <PaginationItem
                {...item}
                components={{ first: FirstPage, last: LastPage }}
              />
            )}
          />
        </Box>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Rows?</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
            <Button onClick={handleDeleteRows} color="error">Delete</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Add New Rab */}
        <Dialog open={openAddRabDialog} onClose={() => setOpenAddRabDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Add New Rab</Typography>
              <IconButton onClick={() => setOpenAddRabDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <TextField
              fullWidth label="RAB Name" name="rabName" margin="normal"
              placeholder="RAB Name" value={rabData.rabName}
              onChange={handleInputChange}
              error={!rabData.rabName}
              helperText={!rabData.rabName ? "Mandatory Field" : ""}
            />
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Project</Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
              {/* Project */}
              {/* Left Side (Inputs & Map) */}
              <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Autocomplete
                    fullWidth
                    options={projectOptions}
                    getOptionLabel={(option) => option.projectName || ""}
                    value={projectOptions.find(opt => opt.id === rabData.projectId) || null}
                    onChange={(event, newValue) => {
                      handleProjectChange({
                        target: {
                          name: "projectId",
                          value: newValue ? newValue.id : ""
                        }
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project Name" name="projectName"
                        placeholder="Enter project name"
                        fullWidth
                        error={!rabData.projectId}
                        helperText={!rabData.projectId ? "Mandatory Field" : ""}
                      />
                    )}
                  />
                  <TextField
                    fullWidth label="Project Code" name="projectReferenceId"
                    placeholder="Enter project address" value={projectAdd.projectReferenceId}
                    disabled
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Value Estimation" name="valueEstimation"
                    placeholder="Enter project address" value={projectAdd.valueEstimation}
                    disabled
                  />

                  <TextField
                    fullWidth label="Project Address" name="projectAddress"
                    placeholder="Enter project address" value={projectAdd.projectAddress}
                    disabled
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>

                </Box>

                {/* Map Placeholder */}
                <Box sx={{ width: "100%", height: "auto", bgcolor: "inherit", display: "flex", alignItems: "center", justifyContent: "center", my: 2 }}>
                  <MapPinLocation
                    latitude={projectAdd.latitude}
                    longitude={projectAdd.longitude}
                    onSelect={({ lat, lng }) => {
                      // if (isEditing) {
                      // setRabData({ ...rabData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                      // else {
                      //   setRabData({ ...rabData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />

                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Latitude" name="latitude"
                    placeholder="Enter latitude" value={projectAdd.latitude}
                    disabled
                  />
                  <TextField
                    fullWidth label="Longitude" name="longitude"
                    placeholder="Enter longitude" value={projectAdd.longitude}
                    disabled
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    select
                    fullWidth label="Region" name="region"
                    placeholder="Enter region" value={projectAdd.region}
                    disabled
                  >
                    <MenuItem value="">Select Region</MenuItem>
                    {regions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    fullWidth label="City" name="city"
                    placeholder="Enter city" value={projectAdd.city}
                    disabled
                  />
                  <TextField
                    fullWidth label="District" name="district"
                    placeholder="Enter district" value={projectAdd.district}
                    disabled
                  />
                </Box>
              </Box>



              {/* Right Side (Dropdowns & Inputs) */}
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                {projectAdd.previewUrl ? (
                  <img
                    src={projectAdd.previewUrl}
                    alt="Existing"
                    style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                  />
                ) : null}
                <TextField
                  select
                  fullWidth label="Project Type" name="projectType"
                  placeholder="Select project type" value={projectAdd.projectType}
                  disabled
                >
                  <MenuItem value="" disabled>Select Project Type</MenuItem>
                  {projectTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  fullWidth label="Source" name="source"
                  placeholder="Select source" value={projectAdd.source}
                  disabled
                >
                  <MenuItem value="" disabled>Select Source</MenuItem>
                  {sources.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  fullWidth label="Construction Phase" name="constructionPhase"
                  placeholder="Select construction phase" value={projectAdd.constructionPhase}
                  disabled
                >
                  <MenuItem value="" disabled>Select Construction Phase</MenuItem>
                  {constructionPhases.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled
                    label="Select Start Date"
                    format="YYYY-MM-DD"
                    value={
                      projectAdd.startDate
                        ? dayjs(projectAdd.startDate)
                        : null
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "startDate",
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled
                    label="Select End Date"
                    format="YYYY-MM-DD"
                    value={
                      projectAdd.endDate
                        ? dayjs(projectAdd.endDate)
                        : null
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "endDate",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>

            {/* AHS */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Input AHS</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>

                <Autocomplete
                  fullWidth
                  options={availableAhsOptions}
                  getOptionLabel={(option) => option.namaAHS || ""}
                  value={
                    ahsData?.id
                      ? availableAhsOptions.find((opt) => opt.id === ahsData.id) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleAhsChange({
                      target: {
                        name: "id",
                        value: newValue ? newValue.id : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name"
                      name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth
                      error={!ahsData.id}
                      helperText={!ahsData.id ? "Mandatory Field" : ""}
                    />
                  )}
                />

                <TextField
                  fullWidth label="AHS Category" name="ahsCategory"
                  placeholder="Enter AHS Category" value={ahsData.category}
                  disabled
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Satuan AHS" name="satuanAHS"
                  placeholder="Enter satuan AHS" value={ahsData.satuanAHS}
                  disabled
                />

                <TextField
                  fullWidth label="Harga Satuan (Rp)" name="hargaSatuan"
                  placeholder="Enter harga satuan AHS" value={ahsData.totalAHS}
                  disabled
                />

                <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={ahsData.volume}
                  onChange={(e) => setAhsData({ ...ahsData, volume: e.target.value, totalHarga: (Number(ahsData.totalAHS) * Number(e.target.value)) })}
                  error={!ahsData.volume}
                  helperText={!ahsData.volume ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={ahsData.totalHarga}
                  disabled
                />
              </Box>

              <Button
                variant="outlined"
                color="primary"
                sx={{ width: 180 }}
                onClick={handleAddAhsToRabDetail}
              >
                Tambahkan ke RAB Detail
              </Button>



            </Box>

            {/* Section A - RAB Review */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. RAB Review</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Keterangan</TableCell>
                    <TableCell>Volume</TableCell>
                    <TableCell>Satuan</TableCell>
                    <TableCell>Harga Satuan</TableCell>
                    <TableCell>Jumlah Harga</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rabDetailAdd.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleDeleteRabDetailRow(index);
                            // setRabDetailAdd((prev) => prev.filter((_, i) => i !== index));
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.namaAHS}</TableCell>
                      <TableCell>{row.volume}</TableCell>
                      <TableCell>{row.satuanAHS}</TableCell>
                      <TableCell>{`Rp ${Number(row.hargaSatuan).toLocaleString("id-ID")}`}</TableCell>
                      <TableCell>{`Rp ${Number(row.totalHarga).toLocaleString("id-ID")}`}</TableCell>
                    </TableRow>
                  ))}
                  {/* Hitungan Akhir */}
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Jumlah</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`Rp ${(totalRabAdd).toLocaleString("id-ID")}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">PPN 11%</TableCell>
                    <TableCell>
                      {`Rp ${Math.round(totalRabAdd * 0.11).toLocaleString("id-ID")}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Total</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`Rp ${Math.round(totalRabAdd * 1.11).toLocaleString("id-ID")}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Terbilang: {terbilang(Math.round(rabDetailAdd.reduce((acc, curr) => acc + Number(curr.totalHarga), 0) * 1.11))} Rupiah
              </Typography>

            </Box>

            {/* S-Curves */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>B. S-Curve</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Autocomplete
                  fullWidth
                  options={availableDetailOptions}
                  getOptionLabel={(option) => option.namaAHS || ""}
                  value={availableDetailOptions.find(opt => opt.ahsId === rabToSCurveAdd.ahsId) || null}
                  onChange={(event, newValue) => {
                    handleDetailChange({
                      target: {
                        name: "ahsId",
                        value: newValue ? newValue.ahsId : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name" name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth error={!rabToSCurveAdd.ahsId}
                      helperText={!rabToSCurveAdd.ahsId ? "Mandatory Field" : ""}
                    />
                  )}
                />
                <TextField
                  fullWidth label="Nilai Pekerjaan" name="nilaiPekerjaan"
                  placeholder="Enter Nilai Pekerjaan" value={String(rabToSCurveAdd.nilaiPekerjaan || "")}
                  onChange={handleSCurveInputChange}
                  disabled
                  error={!rabToSCurveAdd.nilaiPekerjaan}
                  helperText={!rabToSCurveAdd.nilaiPekerjaan ? "Mandatory Field" : ""}
                />
                <TextField
                  fullWidth label="Bobot" name="bobot"
                  placeholder="Enter Bobot" value={String(rabToSCurveAdd.bobot || "")}
                  onChange={handleSCurveInputChange}
                  disabled
                  error={!rabToSCurveAdd.bobot}
                  helperText={!rabToSCurveAdd.bobot ? "Mandatory Field" : ""}
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Durasi (Minggu)" name="durasiMinggu"
                  placeholder="Enter Durasi (Minggu)" value={String(rabToSCurveAdd.durasiMinggu || "")}
                  // disabled
                  onChange={(e) => setRabToSCurveAdd({ ...rabToSCurveAdd, durasiMinggu: e.target.value, endDate: rabToSCurveAdd.startDate ? dayjs(rabToSCurveAdd.startDate).add(Number(e.target.value), 'week').format("YYYY-MM-DD") : "", bobotMingguan: (Number(rabToSCurveAdd.bobot) / Number(e.target.value)) })}
                  error={!rabToSCurveAdd.durasiMinggu}
                  helperText={!rabToSCurveAdd.durasiMinggu ? "Mandatory Field" : ""}
                />
                <TextField
                  fullWidth label="Bobot Mingguan" name="bobotMingguan"
                  placeholder="Enter Bobot Mingguan" value={String(rabToSCurveAdd.bobotMingguan || "")}
                  disabled
                  onChange={handleSCurveInputChange}
                  error={!rabToSCurveAdd.bobotMingguan}
                  helperText={!rabToSCurveAdd.bobotMingguan ? "Mandatory Field" : ""}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select Start Date"
                    format="YYYY-MM-DD"
                    value={rabToSCurveAdd.startDate ? dayjs(rabToSCurveAdd.startDate) : null}
                    onChange={(newValue) => {
                      // if (isEditing) {
                      setRabToSCurveAdd({ ...rabToSCurveAdd, startDate: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "", endDate: newValue ? dayjs(newValue).add(Number(rabToSCurveAdd.durasiMinggu), 'week').format("YYYY-MM-DD") : "" })
                      // }
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1, mt: 0 },
                        name: "startDate",
                        error: !rabToSCurveAdd.startDate,
                        helperText: !rabToSCurveAdd.startDate ? "Mandatory Field" : "",
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled
                    label="Select End Date"
                    format="YYYY-MM-DD"
                    value={rabToSCurveAdd.endDate ? dayjs(rabToSCurveAdd.endDate) : null}
                    onChange={(newValue) => {
                      // if (isEditing) {
                      handleSCurveInputChange({
                        target: {
                          name: "endDate",
                          value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                        },
                      });
                      // }
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1, mt: 0 },
                        name: "endDate",
                        error: !rabToSCurveAdd.endDate,
                        helperText: !rabToSCurveAdd.endDate ? "Mandatory Field" : "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Button
                variant="outlined"
                color="primary"
                sx={{ width: 180 }}
                onClick={handleAddRABToSCurve}
              >
                Tambahkan ke S-Curve
              </Button>



            </Box>

            {/* Section B - S-Curve */}
            <Box sx={{ mt: 5 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Table S-Curve</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Category AHS</TableCell>
                    <TableCell>Keterangan</TableCell>
                    <TableCell>Nilai Pekerjaan</TableCell>
                    <TableCell>Bobot</TableCell>
                    <TableCell>Bobot Minggu</TableCell>
                    <TableCell>Total Durasi</TableCell>
                    <TableCell>Start</TableCell>
                    <TableCell>End</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sCurveAdd.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => {
                            setSCurveAdd((prev) => prev.filter((_, i) => i !== index));
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.namaAHS}</TableCell>
                      <TableCell>{`Rp ${row.nilaiPekerjaan.toLocaleString()}`}</TableCell>
                      <TableCell>{row.bobot}</TableCell>
                      <TableCell>{row.bobotMingguan}</TableCell>
                      <TableCell>{row.durasiMinggu}</TableCell>
                      <TableCell>{row.startDate}</TableCell>
                      <TableCell>{row.endDate}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddRabDialog(false)}>CANCEL</Button>
            <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddRab}>SAVE</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Edit RAB */}
        <Dialog open={openEditRabDialog} onClose={() => setOpenEditRabDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">RAB</Typography>
              <IconButton onClick={() => setOpenEditRabDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <TextField
              fullWidth label="RAB Name" name="rabName" margin="normal"
              placeholder="RAB Name" value={editRabData.rabName}
              onChange={handleInputChangeOnEdit}
              error={!editRabData.rabName}
              helperText={!editRabData.rabName ? "Mandatory Field" : ""}
              disabled={!isEditing}
            />
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Project</Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
              {/* Project */}
              {/* Left Side (Inputs & Map) */}
              <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Autocomplete
                    disabled={!isEditing}
                    fullWidth
                    options={projectOptions}
                    getOptionLabel={(option) => option.projectName || ""}
                    value={projectOptions.find(opt => opt.id === editRabData.projectId) || null}
                    onChange={(event, newValue) => {
                      handleProjectChangeOnEdit({
                        target: {
                          name: "projectId",
                          value: newValue ? newValue.id : ""
                        }
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project Name" name="projectName"
                        placeholder="Enter project name"
                        fullWidth
                        error={!editRabData.projectId}
                        helperText={!editRabData.projectId ? "Mandatory Field" : ""}
                      />
                    )}
                  />
                  <TextField
                    fullWidth label="Project Code" name="projectReferenceId"
                    placeholder="Enter project address" value={projectEdit.projectReferenceId}
                    disabled
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Value Estimation" name="valueEstimation"
                    placeholder="Enter project address" value={projectEdit.valueEstimation}
                    disabled
                  />

                  <TextField
                    fullWidth label="Project Address" name="projectAddress"
                    placeholder="Enter project address" value={projectEdit.projectAddress}
                    disabled
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>

                </Box>

                {/* Map Placeholder */}
                <Box sx={{ width: "100%", height: "auto", bgcolor: "inherit", display: "flex", alignItems: "center", justifyContent: "center", my: 2 }}>
                  <MapPinLocation
                    latitude={projectEdit.latitude}
                    longitude={projectEdit.longitude}
                    onSelect={({ lat, lng }) => {
                      // if (isEditing) {
                      // setRabData({ ...rabData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                      // else {
                      //   setRabData({ ...rabData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />

                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Latitude" name="latitude"
                    placeholder="Enter latitude" value={projectEdit.latitude}
                    disabled
                  />
                  <TextField
                    fullWidth label="Longitude" name="longitude"
                    placeholder="Enter longitude" value={projectEdit.longitude}
                    disabled
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    select
                    fullWidth label="Region" name="region"
                    placeholder="Enter region" value={projectEdit.region}
                    disabled
                  >
                    <MenuItem value="">Select Region</MenuItem>
                    {regions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    fullWidth label="City" name="city"
                    placeholder="Enter city" value={projectEdit.city}
                    disabled
                  />
                  <TextField
                    fullWidth label="District" name="district"
                    placeholder="Enter district" value={projectEdit.district}
                    disabled
                  />
                </Box>
              </Box>



              {/* Right Side (Dropdowns & Inputs) */}
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                {projectEdit.previewUrl ? (
                  <img
                    src={projectEdit.previewUrl}
                    alt="Existing"
                    style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                  />
                ) : null}
                <TextField
                  select
                  fullWidth label="Project Type" name="projectType"
                  placeholder="Select project type" value={projectEdit.projectType}
                  disabled
                >
                  <MenuItem value="" disabled>Select Project Type</MenuItem>
                  {projectTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  fullWidth label="Source" name="source"
                  placeholder="Select source" value={projectEdit.source}
                  disabled
                >
                  <MenuItem value="" disabled>Select Source</MenuItem>
                  {sources.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  fullWidth label="Construction Phase" name="constructionPhase"
                  placeholder="Select construction phase" value={projectEdit.constructionPhase}
                  disabled
                >
                  <MenuItem value="" disabled>Select Construction Phase</MenuItem>
                  {constructionPhases.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled
                    label="Select Start Date"
                    format="YYYY-MM-DD"
                    value={
                      projectEdit.startDate
                        ? dayjs(projectEdit.startDate)
                        : null
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "startDate",
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled
                    label="Select End Date"
                    format="YYYY-MM-DD"
                    value={
                      projectEdit.endDate
                        ? dayjs(projectEdit.endDate)
                        : null
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "endDate",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>

            {/* AHS */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: isEditing ? "flex" : "none", flexDirection: "column", gap: 2, mt: 2 }} hidden={!isEditing}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Input AHS</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Autocomplete
                  disabled={!isEditing}
                  fullWidth
                  options={availableAhsOptionsOnEdit}
                  getOptionLabel={(option) => option.namaAHS || ""}
                  value={
                    editAhsData?.id
                      ? availableAhsOptionsOnEdit.find((opt) => opt.id === editAhsData.id) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleAhsChangeOnEdit({
                      target: {
                        name: "id",
                        value: newValue ? newValue.id : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name" name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth error={!editAhsData.id}
                      helperText={!editAhsData.id ? "Mandatory Field" : ""}
                    />
                  )}
                />
                <TextField
                  fullWidth label="AHS Category" name="ahsCategory"
                  placeholder="Enter AHS Category" value={editAhsData.category}
                  disabled
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Satuan AHS" name="satuanAHS"
                  placeholder="Enter satuan AHS" value={editAhsData.satuanAHS}
                  disabled
                />

                <TextField
                  fullWidth label="Harga Satuan (Rp)" name="hargaSatuan"
                  placeholder="Enter harga satuan AHS" value={editAhsData.totalAHS}
                  disabled
                />

                <TextField
                  disabled={!isEditing}
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={editAhsData.volume}
                  onChange={(e) => setEditAhsData({ ...editAhsData, volume: e.target.value, totalHarga: (Number(editAhsData.totalAHS) * Number(e.target.value)) })}
                  error={!editAhsData.volume}
                  helperText={!editAhsData.volume ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={editAhsData.totalHarga}
                  disabled
                />
              </Box>

              <Button
                disabled={!isEditing}
                variant="outlined"
                color="primary"
                sx={{ width: 180 }}
                onClick={handleAddAhsToRabDetailOnEdit}
              >
                Tambahkan ke RAB Detail
              </Button>



            </Box>

            {/* Section A - RAB Review */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. RAB Review</Typography>
              <Box textAlign={"right"} sx={{ mb: 2 }}>
                <Button
                  onClick={exportRabDetailToPDF}
                  variant="outlined"
                  startIcon={<PictureAsPdf />}
                  color="error"
                >
                  Export PDF
                </Button>
                <Button
                  onClick={exportRabDetailToExcel}
                  variant="outlined"
                  startIcon={<Download />}
                  color="success"
                  sx={{ ml: 1 }}
                >
                  Export Excel
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Keterangan</TableCell>
                    <TableCell>Volume</TableCell>
                    <TableCell>Satuan</TableCell>
                    <TableCell>Harga Satuan</TableCell>
                    <TableCell>Jumlah Harga</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rabDetailAddOnEdit.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          color="error"
                          disabled={!isEditing}
                          onClick={() => {
                            if (isEditing) {
                              handleDeleteRabDetailEdit(index);
                              // setRabDetailAddOnEdit((prev) => prev.filter((_, i) => i !== index));
                              // deleteRabDetail(row.id);
                            }
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.namaAHS}</TableCell>
                      <TableCell>{row.volume}</TableCell>
                      <TableCell>{row.satuanAHS}</TableCell>
                      <TableCell>{`Rp ${Number(row.hargaSatuan).toLocaleString("id-ID")}`}</TableCell>
                      <TableCell>{`Rp ${Number(row.totalHarga).toLocaleString("id-ID")}`}</TableCell>
                    </TableRow>
                  ))}
                  {/* Hitungan Akhir */}
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Jumlah</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`Rp ${(totalRabEdit).toLocaleString("id-ID")}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">PPN 11%</TableCell>
                    <TableCell>
                      {`Rp ${Math.round(totalRabEdit * 0.11).toLocaleString("id-ID")}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Total</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`Rp ${Math.round(totalRabEdit * 1.11).toLocaleString("id-ID")}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Terbilang: {terbilang(Math.round(rabDetailAddOnEdit.reduce((acc, curr) => acc + Number(curr.totalHarga), 0) * 1.11))} Rupiah
              </Typography>

            </Box>

            {/* S-Curves */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: isEditing ? "flex" : "none", flexDirection: "column", gap: 2, mt: 2 }} hidden={!isEditing}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>B. S-Curve</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Autocomplete
                  disabled={!isEditing}
                  fullWidth
                  options={availableDetailOptionsOnEdit}
                  getOptionLabel={(option) => option.namaAHS || ""}
                  value={availableDetailOptionsOnEdit.find(opt => opt.ahsId === rabToSCurveAddOnEdit.ahsId) || null}
                  onChange={(event, newValue) => {
                    handleDetailChangeOnEdit({
                      target: {
                        name: "ahsId",
                        value: newValue ? newValue.ahsId : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name" name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth error={!rabToSCurveAddOnEdit.ahsId}
                      helperText={!rabToSCurveAddOnEdit.ahsId ? "Mandatory Field" : ""}
                    />
                  )}
                />
                <TextField
                  fullWidth label="Nilai Pekerjaan" name="nilaiPekerjaan"
                  placeholder="Enter Nilai Pekerjaan" value={String(rabToSCurveAddOnEdit.nilaiPekerjaan || "")}
                  onChange={handleSCurveInputChangeOnEdit}
                  disabled
                  error={!rabToSCurveAddOnEdit.nilaiPekerjaan}
                  helperText={!rabToSCurveAddOnEdit.nilaiPekerjaan ? "Mandatory Field" : ""}
                />
                <TextField
                  fullWidth label="Bobot" name="bobot"
                  placeholder="Enter Bobot" value={String(rabToSCurveAddOnEdit.bobot || "")}
                  onChange={handleSCurveInputChangeOnEdit}
                  disabled
                  error={!rabToSCurveAddOnEdit.bobot}
                  helperText={!rabToSCurveAddOnEdit.bobot ? "Mandatory Field" : ""}
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Durasi (Minggu)" name="durasiMinggu"
                  placeholder="Enter Durasi (Minggu)" value={String(rabToSCurveAddOnEdit.durasiMinggu || "")}
                  disabled={!isEditing}
                  onChange={(e) => setRabToSCurveAddOnEdit({ ...rabToSCurveAddOnEdit, durasiMinggu: e.target.value, endDate: rabToSCurveAddOnEdit.startDate ? dayjs(rabToSCurveAddOnEdit.startDate).add(Number(e.target.value), 'week').format("YYYY-MM-DD") : "", bobotMingguan: (Number(rabToSCurveAddOnEdit.bobot) / Number(e.target.value)) })}
                  error={!rabToSCurveAddOnEdit.durasiMinggu}
                  helperText={!rabToSCurveAddOnEdit.durasiMinggu ? "Mandatory Field" : ""}
                />
                <TextField
                  fullWidth label="Bobot Mingguan" name="bobotMingguan"
                  placeholder="Enter Bobot Mingguan" value={String(rabToSCurveAddOnEdit.bobotMingguan || "")}
                  disabled
                  onChange={handleSCurveInputChangeOnEdit}
                  error={!rabToSCurveAddOnEdit.bobotMingguan}
                  helperText={!rabToSCurveAddOnEdit.bobotMingguan ? "Mandatory Field" : ""}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled={!isEditing}
                    label="Select Start Date"
                    format="YYYY-MM-DD"
                    value={rabToSCurveAddOnEdit.startDate ? dayjs(rabToSCurveAddOnEdit.startDate) : null}
                    onChange={(newValue) => {
                      if (isEditing) {
                        setRabToSCurveAddOnEdit({ ...rabToSCurveAddOnEdit, startDate: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "", endDate: newValue ? dayjs(newValue).add(Number(rabToSCurveAddOnEdit.durasiMinggu), 'week').format("YYYY-MM-DD") : "" })
                      }
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1, mt: 0 },
                        name: "startDate",
                        error: !rabToSCurveAddOnEdit.startDate,
                        helperText: !rabToSCurveAddOnEdit.startDate ? "Mandatory Field" : "",
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    disabled
                    label="Select End Date"
                    format="YYYY-MM-DD"
                    value={rabToSCurveAddOnEdit.endDate ? dayjs(rabToSCurveAddOnEdit.endDate) : null}
                    onChange={(newValue) => {
                      // if (isEditing) {
                      handleSCurveInputChangeOnEdit({
                        target: {
                          name: "endDate",
                          value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                        },
                      });
                      // }
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1, mt: 0 },
                        name: "endDate",
                        error: !rabToSCurveAddOnEdit.endDate,
                        helperText: !rabToSCurveAddOnEdit.endDate ? "Mandatory Field" : "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Button
                disabled={!isEditing}
                variant="outlined"
                color="primary"
                sx={{ width: 180 }}
                onClick={handleAddRABToSCurveOnEdit}
              >
                Tambahkan ke S-Curve
              </Button>



            </Box>

            {/* Section B - S-Curve */}
            <Box sx={{ mt: 5 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Table S-Curve</Typography>
              <Box textAlign={"right"} sx={{ mb: 2 }}>
                <Button
                  onClick={exportSCurveToPDF}
                  variant="outlined"
                  startIcon={<PictureAsPdf />}
                  color="error"
                >
                  Export PDF
                </Button>
                <Button
                  onClick={exportSCurveToExcel}
                  variant="outlined"
                  startIcon={<Download />}
                  color="success"
                  sx={{ ml: 1 }}
                >
                  Export Excel
                </Button>
              </Box>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Category AHS</TableCell>
                    <TableCell>Keterangan</TableCell>
                    <TableCell>Nilai Pekerjaan</TableCell>
                    <TableCell>Bobot</TableCell>
                    <TableCell>Bobot Minggu</TableCell>
                    <TableCell>Total Durasi</TableCell>
                    <TableCell>Start</TableCell>
                    <TableCell>End</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sCurveAddOnEdit.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          color="error"
                          disabled={!isEditing}
                          onClick={() => {
                            if (isEditing) {
                              setSCurveAddOnEdit((prev) => prev.filter((_, i) => i !== index));
                              setIsEditedSCurve(true);
                              // deleteSCurve(row.id);
                            }
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.namaAHS}</TableCell>
                      <TableCell>{`Rp ${row.nilaiPekerjaan.toLocaleString()}`}</TableCell>
                      <TableCell>{row.bobot}</TableCell>
                      <TableCell>{row.bobotMingguan}</TableCell>
                      <TableCell>{row.durasiMinggu}</TableCell>
                      <TableCell>{row.startDate}</TableCell>
                      <TableCell>{row.endDate}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          <Box sx={{ mt: 5 }} hidden={isEditing} ref={grafanaChartRef}>
            <img
              src={`https://103.23.30.133/api/grafana/render?orgId=1&from=${encodeURIComponent(ifFrom)}&to=${encodeURIComponent(ifTo)}&timezone=browser&var-rabId=${encodeURIComponent(editRabData.id)}&theme=light&panelId=1&width=1000&height=500`}
              alt="SCurve"
              style={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
              crossOrigin="anonymous"
            />
          </Box>
          </DialogContent>


          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            {!isEditing ? (
              // Tombol Edit Muncul di Awal
              <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
                EDIT
              </Button>
            ) : (
              // Tombol Save & Cancel Muncul Saat Edit
              <>
                <Button onClick={() => setIsEditing(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                  CANCEL
                </Button>
                <Button onClick={handleSubmitEditRab} variant="contained" color="success" sx={{ width: 120 }}>
                  SAVE
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>




        {/* ======================= Filter Dialog ============================= */}
        <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
          <DialogTitle>Advanced Search</DialogTitle>
          <DialogContent>
            {filters.map((filter, index) => {
              const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
              const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

              return (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                  <TextField
                    select
                    value={filter.field}
                    onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {availableOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  {filter.field === "projectType" ? (
                    <TextField
                      select
                      label="Project Type"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {projectTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "source" ? (
                    <TextField
                      select
                      label="Source"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {sources.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "region" ? (
                    <TextField
                      select
                      label="Region"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {regions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "constructionPhase" ? (
                    <TextField
                      select
                      label="Project Phase"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {constructionPhases.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "startDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateS ? dayjs(startDateS) : null}
                          onChange={(newValue) =>
                            setStartDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateS ? dayjs(endDateS) : null}
                          onChange={(newValue) =>
                            setEndDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "endDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateE ? dayjs(startDateE) : null}
                          onChange={(newValue) =>
                            setStartDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateE ? dayjs(endDateE) : null}
                          onChange={(newValue) =>
                            setEndDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "valueEstimation" ? (
                    <>
                      <TextField
                        label="Value Min"
                        variant="outlined"
                        size="small"
                        value={valueMin}
                        onChange={(e) =>
                          setValueMin(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                      <TextField
                        label="Value Max"
                        variant="outlined"
                        size="small"
                        value={valueMax}
                        onChange={(e) =>
                          setValueMax(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    </>

                  ) : (
                    <TextField
                      label="Value"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  )}

                  {index > 0 && (
                    <IconButton onClick={() => handleRemoveFilter(index)}>
                      <Remove />
                    </IconButton>
                  )}
                </Box>
              );
            })}

            {filters.length < availableFilters.length && (
              <Button startIcon={<Add />} onClick={handleAddFilter}>
                Add Filter
              </Button>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetFilters}>Reset Filter</Button>
            <Button onClick={handleCloseFilter}>Cancel</Button>
            <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
              {isLoading ? "Loading..." : "Apply"}
            </Button>
          </DialogActions>
        </Dialog>

      </Box>
  );
};

export default RABPage;